import React from 'react';
import { css } from '@emotion/css';
import { Theme, useTheme } from '@mui/material';

interface NavBadgeProps {
  count: number;
  maxCount?: number;
  condensed?: boolean;
}

const NavBadge: React.FC<NavBadgeProps> = ({ count, maxCount = 99, condensed }) => {
  const theme = useTheme();
  const cls = useStyles(theme, { condensed });

  // Don't render if count is 0
  if (count <= 0) return null;

  const displayCount = count > maxCount ? `${maxCount}+` : count.toString();

  return (
    <div className={cls.badge}>
      {displayCount}
    </div>
  );
};

const useStyles = (theme?: Theme, props?: { condensed?: boolean }) => {
  const isCondensed = props?.condensed;

  const styles = {
    badge: isCondensed
      ? css`
          position: absolute;
          top: -3px;
          right: -5px;
          background-color: ${theme?.palette?.error?.main || '#f44336'};
          color: ${theme?.palette?.error?.contrastText || '#ffffff'};
          font-size: 9px;
          font-weight: 700;
          line-height: 1;
          padding: 1px 4px;
          border-radius: 8px;
          min-width: 14px;
          height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          border: 1.5px solid ${theme?.palette?.nav?.sidebar || theme?.palette?.background?.default};
        `
      : css`
          margin-left: auto;
          background-color: ${theme?.palette?.error?.main || '#f44336'};
          color: ${theme?.palette?.error?.contrastText || '#ffffff'};
          font-size: 11px;
          font-weight: 600;
          line-height: 1;
          padding: 2px 6px;
          border-radius: 10px;
          min-width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        `,
  };
  return styles;
};

export default NavBadge;